module.exports = {
  root: '/',
  faq: '/faq',
  thankYou: '/thank-you',
  termsOfUse: '/terms-of-use',
  privacyPolicy: '/privacy-policy',
  cookieConsent: '/cookie-policy',
  company: '/company',
  aboutCompany: '/about-company',
  aboutUs: '/about-us',
  contactUs: '/contact-us',
  validate: '/validate',
  submitAJob: '/submit-a-job',
  githubAuth: '/github-auth',
  validatorsLeaderboard: '/validators-leaderboard',
  becomeAValidator: '/become-a-validator',
  merkle: '/admin/merkle',
  chatbotView: '/chatbot/user/:skillName',
  devControlPanel: {
    root: '/dev-control-panel',
    auditTrail: '/dev-control-panel/audit-trail',
  },
  imports: {
    linkedInCsv: '/imports/linked-in-csv',
  },
  auth: {
    signUp: '/sign-up',
    verificationEmailSent: '/verification-email-sent',
    resendVerificationEmail: '/resend-verification-email',
    verifyEmail: '/verify-email',
    login: '/login',
    changePassword: '/password/change',
    setPassword: '/password/set',
    linkedAccounts: '/linked-accounts',
    forgotPassword: '/password/forgot',
    resetPassword: '/password/reset',
    approvalRequired: '/approval-required',
  },
  users: {
    root: '/users',
    myProfile: '/profile',
    profile: '/users/:id',
    vanityProfile: '/:username',
    delete: '/users/delete',
  },
  roles: {
    root: '/select-roles',
    skills: '/select-skills',
  },
  admin: {
    root: '/admin',
    users: {
      index: '/admin/users',
    },
    templates: {
      root: '/admin/templates',
    },
    preassess: {
      root: '/admin/pre-assess',
      new: '/admin/pre-assess/new',
      edit: '/admin/pre-assess/:id/edit',
    },
    behavassess: {
      root: '/admin/behav-assess',
      new: '/admin/behav-assess/new',
      edit: '/admin/behav-assess/:id/edit',
    },
    companies: {
      root: '/admin/companies',
      new: '/admin/companies/new',
      edit: '/admin/companies/:prettyId/edit/:section?',
      accept: '/company/:token',
    },
    profiler: {
      root: '/admin/profiler_runs',
      new: '/admin/profiler_runs/new',
      details: '/admin/profiler_runs/:id/details/:section?',
    },
    hiring: {
      root: '/admin/hiring-companies',
      new: '/admin/hiring-companies/new',
    },
    skills: {
      root: '/admin/skills',
      new: '/admin/skills/new',
      edit: '/admin/skills/:name/edit',
    },
    badges: {
      root: '/admin/badges',
      new: '/admin/badges/new',
      edit: '/admin/badges/:prettyId/edit',
      assign: '/admin/badges/assign',
    },
    claims: {
      root: '/admin/claims',
    },
    jobs: {
      root: '/admin/jobs',
      edit: '/admin/jobs/:id/edit',
      applicants: '/admin/jobs/:id/applicants',
      referrals: '/admin/jobs/:id/referrals',
    },
    assignments: {
      root: '/admin/assignments',
      new: '/admin/assignments/new',
      edit: '/admin/assignments/:id/edit',
    },
    stats: {
      root: '/admin/stats',
    },
    validators: {
      details: '/admin/validator/:validator_id',
      add: '/admin/validator-add',
      update: '/admin/validator-update/:validator_id',
    },
    features: {
      root: '/admin/features',
      new: '/admin/features/new',
      edit: '/admin/features/:id/edit',
    },
  },
  validatorFeatures: {
    root: '/validator-features',
    new: '/validator-features/new',
    details: '/validator-features/:id',
  },
  claims: {
    root: '/claims',
    my: '/claims',
    new: '/claims/new',
    details: '/claims/:id',
    verify: '/claims/verify',
    detailsViewPdf: '/claims/view-pdf/:id',
  },
  votes: {
    root: '/votes',
    my: '/votes',
    cast: '/votes/:claimId/cast', // Maybe it should be vote id and not claim id
  },
  companies: {
    vanityProfile: '/c/:prettyId',
    acceptAsAdvisor: '/c/:prettyId/accept-as-advisor/:advisoryId',
    revokeAsAdvisor: '/c/:prettyId/revoke-as-advisor/:advisoryId',
    acceptAsTeamMember: '/c/:prettyId/accept-as-team/:teamMembershipId',
    revokeAsTeamMember: '/c/:prettyId/revoke-as-team/:teamMembershipId',
    root: '/companies',
    listing: {
      root: '/companies/listing',
    },
    acceptAdvisorConnection: '/companies/:prettyId/advisors/:id',
    edit: '/companies/:prettyId/edit/:section?',
    magicLinkCandidates: '/companies/:prettyId/edit/candidates/view/:publicId',
    hiringDashboard: '/:prettyId/dashboard',
  },
  blockchain101: {
    root: '/blockchain101',
  },
  wizard: {
    signUp: '/wizards/signUp',
  },
  badges: {
    root: '/badges',
    details: '/badges/:prettyId',
  },
  assignments: {
    myEvaluations: '/my-evaluations',
    root: '/assignments',
    thanks: '/assignment-submitted',
    details: '/assignments/:assignmentId',
  },
  magicLinks: {
    assessmentMagicLink: '/program-evaluation/:publicId',
  },
  partner: {
    acceptInvite: '/partner/accept-invite',
  },
  profiler: {
    candidateAcceptInvite: '/profiler/user/:token',
    details: '/profiler_runs/:id/details/:section?',
    inviteCandidateToChatbots: '/profiler_runs/invite_chatbots/:profilerRunId/:profilerCandidateId',
  },
  program: {
    user: '/program/user/:token',
    platformUser: '/platform/user/:token',
    behaviouralAssessment: '/behavioural-assessment/:publicId',
  },
  claimReports: {
    details: '/claim-reports/:reportId',
  },
  chatbotReports: {
    details: '/chatbot-reports/:profilerCandidateId',
  },
  chatbotQuiz: {
    quiz: '/chatbot-reports/:profilerCandidateId/quiz',
  },
};



// WEBPACK FOOTER //
// ./src/ui/common/routes/templates.js